import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { ActionSheetContent } from '@/components/action-sheet';
import { useCartActions } from './hooks/use-cart-actions';

interface Props {
  onCancel: () => void;
  onDeleted: () => void;
  orderUUID: string | null;
}

export const DeleteCartConfirmation: React.FC<Props> = ({
  onCancel,
  onDeleted,
  orderUUID,
}) => {
  const { carts, deleteCart } = useCartActions();
  const [isDeleting, setIsDeleting] = useState(false);
  const cart = carts.find((entry) => entry.orderUUID === orderUUID);

  return (
    <ActionSheetContent
      actions={[i18n.t('multi_cart.delete_cart'), i18n.t('cancel')]}
      horizontalButtons
      loadingActionIndex={isDeleting ? 0 : null}
      message={i18n.t('multi_cart.delete_cart_body', {
        name: cart?.name ?? '',
      })}
      onAction={async (_, index) => {
        if (index !== 0 || !orderUUID) {
          onCancel();
          return;
        }
        setIsDeleting(true);
        try {
          if (await deleteCart(orderUUID)) {
            onDeleted();
          }
        } finally {
          setIsDeleting(false);
        }
      }}
      title={i18n.t('multi_cart.delete_cart_title')}
    />
  );
};
